// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alphabetNavigationStyles } from "@tps/Overrides/Widgets/Brand/AlphabetNavigation";
import Search from "@tps/XDL/Icons/Search";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

alphabetNavigationStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        background-color: ${color("common.ui2")};
        padding: 20px;
        gap: 30px;
        margin-block: 52px;
        ${xScreen("lte", "md")} {
            gap: 20px;
            padding: 16px;
        }
        
        ${xScreen("lt", "sm")} {
            gap: 16px;
            flex-direction: column;
        }
    `,
};

alphabetNavigationStyles.titleText = {
    size: 16,
    lineHeight: "22px",
    weight: "bold",
    css: css`
        margin-bottom: 11px;
        letter-spacing: 0;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

alphabetNavigationStyles.brandsLettersWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-transform: capitalize;
        flex-wrap: wrap;
    `,
};

alphabetNavigationStyles.navigationItem = {
    css: css`
        display: inline-flex;

        ${({ enabled }: any) =>
            !enabled &&
            css`
                color: ${color("text.disabled")};
            `}
        ${({ selectedLetter }: any) =>
            selectedLetter &&
            css`
                text-decoration: underline;
            `}
    `,
};

alphabetNavigationStyles.navigationLink = {
    css: css`
        &:focus {
            outline: none;
        }
    `,
    typographyProps: {
        transform: "capitalize",
        forwardAs: "span",
        size: 16,
        weight: "bold",
        mergeCss: true,
        css: css`
            span:first-letter {
                text-transform: uppercase;
            }
            text-align: center;
            display: block;
            letter-spacing: 0;
            line-height: 26px;
            &&& {
                color: ${color("text")};
            }
        `,
    },
};

alphabetNavigationStyles.navigationTextEmpty = {
    transform: "capitalize",
    variant: "headerTertiary",
    forwardAs: "span",
    size: 16,
    weight: "bold",
    css: css`
        text-align: center;
        display: block;
        letter-spacing: 0;
        line-height: 26px;
        opacity: 0.5;
        cursor: not-allowed;
    `,
};

alphabetNavigationStyles.alphabetSection = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding-top: 5px;

        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

alphabetNavigationStyles.filterInput = {
    cssOverrides: {
        formField: css`
            &,
            input {
                height: 36px;
            }
            ${xScreen("lte", "sm")} {
                padding: 0;
            }
            > div {
                height: 100%;
            }
        `,
    },
    iconProps: {
        src: Search,
        color: "common.ui5",
    },
};

alphabetNavigationStyles.selectWrapper = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            &&& {
                display: block;
                width: 100%;
            }
        }
    `,
};

alphabetNavigationStyles.fullWidth = {
    css: css`
        width: 50%;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
